// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_jgZDD","adjustFontStyle":"index_adjustFontStyle_4CMn-"};